import { newLogger } from "@/utils/util";
import StoreCore from "../../../StoreCore";

let logger = newLogger("Enterprise-Aggregation");

const urls = {
  setting: (id) => `/enterprise/aggregation/setting/${encodeURIComponent(id)}`,
  settingStar: (id) =>
    `/enterprise/aggregation/setting/star/${encodeURIComponent(id)}`,
  settings: "/enterprise/aggregation/settings",
};

const initState = () => {
  return {
    aggregationSettings: {},
    aggregationSetting: {},
  };
};

const storeCore = new StoreCore();
const actions = {
  fetchSettings: async function ({ commit, dispatch }) {
    try {
      let data = await this.remoteRequest(
        "get",
        urls.settings,
        null,
        true,
        dispatch,
        "Aggregációs nézetek letöltése...",
        undefined,
        true
      );
      commit("saveSettings", data);
    } catch (err) {
      if ("Cached!" !== err) {
        logger.error(err);
      }
    }
  }.bind(storeCore),

  fetchSetting: async function ({ commit, dispatch }, id) {
    try {
      let data = await this.remoteRequest(
        "get",
        urls.setting(id),
        null,
        true,
        dispatch,
        "Aggregációs nézet letöltése..."
      );
      commit("saveSetting", data);
    } catch (err) {
      if ("Cached!" !== err) {
        logger.error(err);
      }
    }
  }.bind(storeCore),

  createSetting: async function ({ commit, dispatch }, aggregationSetting) {
    try {
      let data = await this.remoteRequest(
        "post",
        urls.settings,
        aggregationSetting,
        true,
        dispatch,
        "Aggregációs nézet mentése...",
        undefined,
        undefined,
        false,
        true,
        {
          progress:
            "projectAggregation.create.progress|Nézet létrehozása folyamatban...",
          fail: "projectAggregation.create.fail|Nézet létrehozása sikertelen!",
          success:
            "projectAggregation.create.success|Nézet létrehozása sikeres!",
        }
      );
      commit("saveSetting", data);
      return data.id;
    } catch (err) {
      if ("Cached!" !== err) {
        logger.error(err);
      }
    }
  }.bind(storeCore),

  editSetting: async function (
    { commit, dispatch },
    { id, aggregationSetting }
  ) {
    try {
      let data = await this.remoteRequest(
        "put",
        urls.setting(id),
        aggregationSetting,
        true,
        dispatch,
        "Aggregációs nézet mentése...",
        undefined,
        undefined,
        false,
        true,
        {
          progress:
            "projectAggregation.edit.progress|Nézet szerkesztése folyamatban...",
          fail: "projectAggregation.edit.fail|Nézet szerkesztése sikertelen!",
          success:
            "projectAggregation.edit.success|Nézet szerkesztése sikeres!",
        }
      );
      commit("saveSetting", data);
    } catch (err) {
      if ("Cached!" !== err) {
        logger.error(err);
      }
    }
  }.bind(storeCore),

  starSetting: async function ({ commit, dispatch }, id) {
    try {
      let data = await this.remoteRequest(
        "put",
        urls.settingStar(id),
        null,
        true,
        dispatch,
        "Aggregációs nézet frissítése..."
      );
      commit("saveSetting", data);
    } catch (err) {
      if ("Cached!" !== err) {
        logger.error(err);
      }
    }
  }.bind(storeCore),

  deleteSetting: async function ({ commit, dispatch }, id) {
    try {
      await this.remoteRequest(
        "delete",
        urls.setting(id),
        null,
        true,
        dispatch,
        "Aggregációs nézet törlése...",
        undefined,
        undefined,
        false,
        true,
        {
          progress:
            "projectAggregation.delete.progress|Nézet törlése folyamatban...",
          fail: "projectAggregation.delete.fail|Nézet törlése sikertelen!",
          success: "projectAggregation.delete.success|Nézet törlése sikeres!",
        }
      );
      commit("deleteSetting", id);
    } catch (err) {
      if ("Cached!" !== err) {
        logger.error(err);
      }
    }
  }.bind(storeCore),

  clearCache: async function ({}) {
    this.clearCoreCache();
  }.bind(storeCore),
};

const mutations = {
  saveSettings: (state, data) => {
    state.aggregationSettings = data;
  },
  saveSetting: (state, data) => {
    if (data.filterSettings.from) {
      data.filterSettings.from = new Date(data.filterSettings.from);
    }
    if (data.filterSettings.to) {
      data.filterSettings.to = new Date(data.filterSettings.to);
    }
    state.aggregationSetting[data.id] = data;
  },
  deleteSetting: (state, id) => {
    delete state.aggregationSettings[id];
  },
};

const getters = {
  settings: (state) => {
    return state.aggregationSettings;
  },
  setting: (state) => (id) => {
    return state.aggregationSetting[id];
  },
};

export default {
  namespaced: true,
  state: initState(),
  mutations: mutations,
  actions: actions,
  getters: getters,
};
